import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from "react";

export const TopFeatureCard: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="flex flex-col border-solid border border-gray-200 rounded-2xl px-6 py-7 text-black gap-4 transition ease-in-out duration-300">
            {children}
            <style jsx>{`
                :hover {
                    box-shadow: 0px 32px 60px rgba(0, 0, 0, 0.1);
                }
            `}</style>
        </div>
    );
};

type BenefitsCardProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const BenefitsCard: React.FC<BenefitsCardProps> = ({ children, ...containerProps }) => {
    const { className, ...restProps } = containerProps;
    return (
        <div
            className={`flex-1 bg-white flex flex-col gap-4 justify-center items-center text-center rounded-2xl px-8 py-8 text-black transition ease-in-out duration-300 ${className}`}
            {...restProps}
        >
            {children}
            <style jsx>{`
                :hover {
                    box-shadow: 0px 32px 60px rgba(0, 0, 0, 0.1);
                }
            `}</style>
        </div>
    );
};

export const BenefitsCard2: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="flex-1 bg-green-100 flex flex-col gap-2 justify-center items-center text-center border-solid border border-gray-200 rounded-2xl px-8 py-7 text-green-900 transition ease-in-out duration-300">
            {children}
            <style jsx>{`
                :hover {
                    box-shadow: 0px 32px 60px rgba(0, 0, 0, 0.1);
                }
            `}</style>
        </div>
    );
};
